import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { REPLACE_COURSE_TYPE_MUTATION } from '../graphql/mutations'
import { REPLACE_COURSE_TYPE } from '../redux/action-types'

const useReplaceCourseTypeMutation = refetchLastEvent => {
  const dispatch = useDispatch()

  const { isLoading, error } = useSelector(
    store => store.courseTypes.courseTypes,
  )

  const mutate = useCallback(
    async ({ idToReplace, replacementId }) => {
      await apolloService.mutate(
        REPLACE_COURSE_TYPE_MUTATION,
        {
          idToReplace,
          replacementId,
        },
        dispatch,
        REPLACE_COURSE_TYPE,
      )

      refetchLastEvent()
    },
    [dispatch, refetchLastEvent],
  )

  return [mutate, { isLoading, error }]
}

export default useReplaceCourseTypeMutation
